import PlayButton, { ButtonType } from 'app/ui-components/PlayButton/PlayButton';
import SvtLogoWhite from 'public/static/images/sprite/svt-logo-white.png';
import styled from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import { iconCog, regularBlack, regularWhite } from '../../ui-components/design-tokens';
import { playFontIcon, playFontSize } from '../../ui-components/typography/helpers';
import { ClearFix } from '../../ui-components/utils.styles';
import ExternalLink from '../ExternalLink/ExternalLink';

export const FooterContainer = styled.footer`
    ${ClearFix}
    color: ${regularWhite};
    display: block;
    position: relative;
    margin-top: 10px;
    flex: 0 0 auto;
    background-color: ${regularBlack};
    z-index: 0;

    @media ${device.GteSmall} {
        margin-top: 20px;
    }

    @media ${device.GteLarge} {
        margin-top: 30px;
    }

    @media print {
        display: none !important;
    }
`;

export const FooterLogo = styled.span`
    background-image: url(${SvtLogoWhite});
    width: 50px;
    height: 28px;

    display: inline-block;
    margin: 2px 0 15px 0;
`;

export const IconContainer = styled.div`
    margin-top: 30px;
    text-align: center;
    display: block;
`;

export const Buttons = styled.div`
    margin-top: 30px;
    text-align: center;

    .no-js & {
        display: none;
    }
`;

export const Button = styled(PlayButton).attrs({ buttonType: ButtonType.LINK })`
    margin: 5px 10px;

    @media ${device.GteSmall} {
        display: inline-block;
        margin: 0 5px;
    }
`;

Button.displayName = 'FooterButton';

export const CogIcon = styled.span`
    margin-right: 5px;
    &:before {
        ${playFontIcon(1.5, iconCog)}
    }
`;

export const Services = styled.div`
    padding: 0;
    margin: 30px auto 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media ${device.GteSmall} {
        flex-direction: row;
    }
`;

export const ServicesLinkWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0 50px;

    @media ${device.GteSmall} {
        margin: 0;
    }
`;

export const Service = styled.p`
    display: inline-block;
    ${playFontSize(1.2)};

    &:nth-child(even) {
        float: right;

        @media ${device.GteSmall} {
            float: none;
        }
    }
    @media ${device.GteSmall} {
        ${playFontSize(1.3)};
    }
`;

Service.displayName = 'Service';

export const ServiceLink = styled(ExternalLink)`
    display: inline-block;
    padding: 5px;

    @media ${device.GteSmall} {
        padding: 10px;
    }
`;
